import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { StackedVerticalBarComponent } from './stacked-vertical-bar.component';

@NgModule({
  declarations: [
    StackedVerticalBarComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,
    NgxChartsModule,
    NgxSkeletonLoaderModule
  ],
  exports: [
    StackedVerticalBarComponent
  ]
})
export class StackedVerticalBarModule { }
